import belted_kingfisher from '../assets/birds/belted_kingfisher.jpg';
import budgie from '../assets/birds/budgie.jpg';
import common_kingfisher from '../assets/birds/common_kingfisher.jpg';
import golden_parakeet from '../assets/birds/golden_parakeet.jpg';
import kingfisher_fishing from '../assets/birds/kingfisher_fishing.jpg';
import orangechinned_parakeet from '../assets/birds/orangechinned_parakeet.jpg';
import sun_parakeet from '../assets/birds/sun_parakeet.jpg';
import whitethroated_kingfisher from '../assets/birds/whitethroated_kingfisher.jpg';

import cck_cabinet from '../assets/profilepage/choachukang/cabinet.jpg';
import cck_bedroom from '../assets/profilepage/choachukang/bedroom.jpg';
import cck_livingroom from '../assets/profilepage/choachukang/livingroom.jpg';
import cck_shower from '../assets/profilepage/choachukang/shower.jpg';
import cck_kitchen from '../assets/profilepage/choachukang/kitchen.jpg';
import cck_sink from '../assets/profilepage/choachukang/sink.jpg';

import cr_wardrobe from '../assets/profilepage/circuitroad/wardrobe.jpg';
import cr_shower2 from '../assets/profilepage/circuitroad/shower2.jpg';
import cr_livingroom from '../assets/profilepage/circuitroad/livingroom.jpg';
import cr_kitchen from '../assets/profilepage/circuitroad/kitchen.jpg';
import cr_dresser from '../assets/profilepage/circuitroad/dresser.jpg';
import cr_diningarea from '../assets/profilepage/circuitroad/diningarea.jpg';
import cr_bedroom from '../assets/profilepage/circuitroad/bedroom.jpg';

import st_cabinetry from '../assets/profilepage/sunriseterrace/cabinetry.jpg';
import st_bedroom from '../assets/profilepage/sunriseterrace/bedroom.jpg';
import st_wardrobe from '../assets/profilepage/sunriseterrace/wardrobe.jpg';
import st_livingroom2 from '../assets/profilepage/sunriseterrace/livingroom2.jpg';
import st_kitchen from '../assets/profilepage/sunriseterrace/kitchen.jpg';
import st_idontknow from '../assets/profilepage/sunriseterrace/idontknow.jpg';

export const PROFILE_BLURB = `Cindy Tan is an experienced interior designer 

...`;


interface PortfolioItem {
  image: string;
  caption: string;
	blurhash: string;
}

interface PortfolioProject {
	date: string;
	title: string;
	description: string;
	portfolioItems: PortfolioItem[];
}

const choachukang_project: PortfolioProject = {
	date: '2024',
	title: 'HDB | Choa Chu Kang',
	description: 'A modern and functional home renovation (more text...)',
	portfolioItems: [
		{ image: cck_livingroom, caption: 'Living Room' , blurhash: 'LcKxSXodITxv_4x]xuRjMxRjj?ae'},
		{ image: cck_bedroom, caption: 'Bedroom' , blurhash: 'LRMtdb?w%J%KyEM{oIt6w?xVIWIV'},
		{ image: cck_kitchen, caption: 'Kitchen' , blurhash: 'LOIZ3r%N8^tS?vskozn#^dE2T1M{'},
		{ image: cck_cabinet, caption: 'Cabinet' , blurhash: 'LQK_B|Mw_2i_?cRkWBWU_4%hIpX9'},
		{ image: cck_shower, caption: 'Shower' , blurhash: 'LTNv;}vdxtx].TX9WBIU9cRjWAt7'},
		{ image: cck_sink, caption: 'Sink' , blurhash: 'LTMHDP^*.8aJ~qogRkWUIX%Mt6xt'},
	]
}

const circuitroad_project: PortfolioProject = {
	date: '2024',
	title: 'HDB | Circuit Road',
	description: 'A striking contemporary home (more text...)',
	portfolioItems: [
		{ image: cr_livingroom, caption: 'Living Room' , blurhash: 'LaMQea.9IAWC_4ogWBWBbHn#t7jZ'},
		{ image: cr_bedroom, caption: 'Bedroom' , blurhash: 'LLMjj$TKIAIUD%M{t8RP?wxuM|t8'},
		{ image: cr_kitchen, caption: 'Kitchen' , blurhash: 'LnKUD*IURiae~pWCNHofRixtayWV'},
		{ image: cr_diningarea, caption: 'Dining Area' , blurhash: 'LUK1L5rn9aE2~qs+RlRjrpkDt8s+'},
		{ image: cr_wardrobe, caption: 'Wardrobe' , blurhash: 'LIKdMS-q4:%M~Ub{x^tR^+jE9FRj'},
		{ image: cr_dresser, caption: 'Dresser' , blurhash: 'LELDroMwI9kX~p$dX9RjH?t7%Nxu'},
		{ image: cr_shower2, caption: 'Shower' , blurhash: 'LWI=JhxZofM__N-=WBaxogt7t7og'},
	]
}

const sunriseterrace_project: PortfolioProject = {
	date: '2025',
	title: 'Landed | Sunrise Terrace',
	description: 'A bright and modern terrace home renovation (more text...)',
	portfolioItems: [
		{ image: st_livingroom2, caption: 'Living Room' , blurhash: 'LGKBO4t64ntS~V%MM_xtI9%0-;V@'},
		{ image: st_bedroom, caption: 'Bedroom' , blurhash: 'LQMH79yEx^x]?^V?kDs,roocVrae'},
		{ image: st_kitchen, caption: 'Kitchen' , blurhash: 'LWNAn^~qt7t7?uM{M{of4oRjRjay'},
		{ image: st_cabinetry, caption: 'Cabinetry' , blurhash: 'LMIhA~NO_3R.~p%3xukD4;xtV@WB'},
		{ image: st_wardrobe, caption: 'Wardrobe' , blurhash: 'LOIqiWRj0LtR_M%1M|xaIUkD%2WB'},
		{ image: st_idontknow, caption: 'Feature Area' , blurhash: 'LTKBH[D%8_x]~qxuozM{S6xtR*xa'},
	]
}

export const PROJECTS: PortfolioProject[] = [choachukang_project, circuitroad_project, sunriseterrace_project];
export const PROJECT_NAMES: string[] = PROJECTS.map((project: PortfolioProject) => project.title);